export default __webpack_public_path__ + "static/media/up.f53aa0f4.svg";